import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuperstructureEasysuiteComponent } from './components/easysuite-superstructure/easysuite-superstructure.component';
import { GlobalSharedModule } from '../global-shared/global-shared.module';
import { BaseModule } from '../base/base.module';
import { MaterialModule } from '../material/material.module';
import { NgChartsModule  } from 'ng2-charts';

// We import the GM module to use the login component.
import { GigmonsterModule } from '../gigmonster/gigmonster.module';

import { EasysuiteHeaderComponent } from './components/easysuite-header/easysuite-header.component';
import { EasysuiteTopNavComponent } from './components/easysuite-top-nav/easysuite-top-nav.component';
import { EasysuiteSideNavComponent } from './components/easysuite-side-nav/easysuite-side-nav.component';
import { EasysuiteTableComponent } from './components/easysuite-table/easysuite-table.component';
import { EasysuiteFormComponent } from './components/easysuite-form/easysuite-form.component';
import { EasysuiteMobileNavComponent } from './components/easysuite-mobile-nav/easysuite-mobile-nav.component';
import { EasysuiteCheckboxComponent } from './components/easysuite-fields/easysuite-checkbox/easysuite-checkbox.component'; 
import { EasysuiteDatepickerComponent } from './components/easysuite-fields/easysuite-datepicker/easysuite-datepicker.component';
import { EasysuiteDropdownComponent } from './components/easysuite-fields/easysuite-dropdown/easysuite-dropdown.component';
import { EasysuiteMultiCheckboxComponent } from './components/easysuite-fields/easysuite-multi-checkbox/easysuite-multi-checkbox.component';
import { EasysuiteMultilevelCheckboxComponent } from './components/easysuite-fields/easysuite-multilevel-checkbox/easysuite-multilevel-checkbox.component';
import { EasysuiteMultilevelCheckboxNonselectComponent } from './components/easysuite-fields/easysuite-multilevel-checkbox-nonselect/easysuite-multilevel-checkbox-nonselect.component';
import { EasysuiteRadioComponent } from './components/easysuite-fields/easysuite-radio/easysuite-radio.component';
import { EasysuiteTextareaComponent } from './components/easysuite-fields/easysuite-textarea/easysuite-textarea.component';
import { TextfieldComponent } from './components/easysuite-fields/easysuite-textfield/easysuite-textfield.component';
import { TimepickerComponent } from './components/easysuite-fields/easysuite-timepicker/easysuite-timepicker.component';
import { UploadComponent } from './components/easysuite-fields/easysuite-upload/easysuite-upload.component';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { EasysuiteLoginComponent } from './components/easysuite-login/easysuite-login.component';
import { EasysuitePasswordComponent } from './components/easysuite-fields/easysuite-password/easysuite-password.component';
import { EasysuiteChartsComponent } from './components/easysuite-charts/easysuite-charts.component';
import { EasysuitePageTextComponent } from './components/easysuite-fields/easysuite-page-text/easysuite-page-text.component';
import { EasysuiteLoaderComponent } from './components/easysuite-loader/easysuite-loader.component';
import { FluidpayTokenizerComponent } from './components/fluidpay-tokenizer/fluidpay-tokenizer.component';
@NgModule({
  declarations: [
    SuperstructureEasysuiteComponent,
    EasysuiteHeaderComponent,
    EasysuiteTopNavComponent,
    EasysuiteSideNavComponent,
    EasysuiteTableComponent,
    EasysuiteFormComponent,
    EasysuiteMobileNavComponent,
    EasysuiteLoginComponent,
    EasysuiteCheckboxComponent,
    EasysuiteDatepickerComponent,
    EasysuiteDropdownComponent,
    EasysuiteMultiCheckboxComponent,
    EasysuiteMultilevelCheckboxComponent,
    EasysuiteMultilevelCheckboxNonselectComponent,
    EasysuiteRadioComponent,
    TextfieldComponent,
    TimepickerComponent,
    UploadComponent,
    EasysuiteTextareaComponent,
    EasysuitePasswordComponent,
    EasysuiteChartsComponent,
    EasysuitePageTextComponent,
    EasysuiteLoaderComponent,
    FluidpayTokenizerComponent
  ],
  imports: [
    CommonModule,
    GlobalSharedModule,
    BaseModule,
    MaterialModule,
    MatFormFieldModule,
    NgChartsModule,
    GigmonsterModule
  ],
  exports: [
    EasysuiteLoginComponent,
    FluidpayTokenizerComponent
  ]
})
export class EasysuiteModule { }
